/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 23 2024
 **/

import { useAtomCallback } from "jotai/utils";

import { useMyDeskActions } from "@/frameworks/core/API";
import { WidgetAtom } from "./atom";

export default function useSaveMyDesk() {
	const myDeskAPI = useMyDeskActions();

	const saveWidgetState = useAtomCallback(async (get, _, notificationState, fileState, totalShortcutList) => {
		const prevState = get(WidgetAtom);

		await myDeskAPI.configure.saveWidget.execute({
			widget: JSON.stringify({
				...prevState,
				widgetState: {
					notification: notificationState,
					recentFile: fileState
				},
				shortcuts: totalShortcutList
			})
		});
	});

	return {
		saveWidgetState
	};
}
